"use client";
import { jsx as i } from "react/jsx-runtime";
import { Slot as s } from "@radix-ui/react-slot";
import { cva as d } from "class-variance-authority";
import * as c from "react";
import { cn as u } from "./index15.js";
const f = d(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-brand-primary text-brand-primary-foreground hover:opacity-90",
        destructive: "bg-feedback-error text-text-inverse hover:opacity-90",
        outline: "border border-border bg-surface hover:bg-surface-raised hover:text-text",
        secondary: "bg-surface-raised text-text hover:bg-surface-overlay",
        ghost: "hover:bg-surface-raised hover:text-text",
        link: "text-brand-accent underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-sm px-3 text-xs",
        lg: "h-10 rounded-lg px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), l = c.forwardRef(
  ({ className: e, variant: t, size: r, asChild: o = !1, ...a }, n) => /* @__PURE__ */ i(o ? s : "button", { className: u(f({ variant: t, size: r, className: e })), ref: n, ...a })
);
l.displayName = "Button";
export {
  l as Button,
  f as buttonVariants
};
//# sourceMappingURL=index6.js.map
